export default {
    sizeUsersToAprove : 0,
    user : {},
    userInfo : {},
    selectedCompany : null,
    selectedCompanyObj : null,
    permissao : [],
    alertas : [],
    listaEmpresas : []
}